import { Link } from 'react-router-dom'
import { trackFunnel } from '@/lib/funnel'
import {
  landingHeaderCtaClass,
  landingSecondaryCtaClass,
} from '@/components/landing/landingStyles'
import { useLandingCopy } from '@/hooks/useGuestLocale'

export function LandingFinalCta() {
  const copy = useLandingCopy()

  return (
    <section
      className="mt-10 border-t border-slate-900/[0.06] pt-10 sm:mt-12 sm:pt-12"
      data-testid="landing-final-cta"
    >
      <div className="mx-auto max-w-lg text-center">
        <h2 className="text-balance text-xl font-semibold tracking-tight text-foreground sm:text-2xl">
          {copy.finalTitle}
        </h2>

        <div className="mt-6 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center sm:justify-center">
          <Link
            to="/register"
            className={landingHeaderCtaClass}
            onClick={() => trackFunnel('REGISTER_CLICK', { source: 'final' })}
          >
            {copy.getStarted}
          </Link>
          <Link to="/login" className={landingSecondaryCtaClass}>
            {copy.signIn}
          </Link>
        </div>
      </div>
    </section>
  )
}
